import React, { useEffect } from "react";
import { Container, Table, Pagination, Card } from "react-bootstrap";
import "../../plans.css";
import { IoIosArrowForward, IoMdTrash } from "react-icons/io";
import { useNavigate, Link } from "react-router-dom";
import { getPlan } from "../../store/slices/plan";
import { useSelector, useDispatch } from "react-redux";
import { MdEdit } from "react-icons/md";
import { toast } from "react-toastify";

export default function Plans() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { planlist = [], loading } = useSelector((state) => state.plan);

  const plans = Array.isArray(planlist)
    ? planlist
    : Array.isArray(planlist?.data)
      ? planlist.data
      : [];

  console.log(plans);

  useEffect(() => {
    dispatch(getPlan())
      .unwrap()
      .catch((err) => {
        toast.error(err?.message || "Failed to load plans.");
      });
  }, [dispatch]);


  const getStatusClass = (status) => (status === true ? "active" : "inactive");
  const getStatusLabel = (status) =>
    status === true ? "● Active" : "○ Inactive";


  return (
    <>
      <div className="breadcrumb-bar mb-4">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>
          <span className="breadcrumb-separator">
            <IoIosArrowForward size={15} />
          </span>
          <span className="breadcrumb-link inactive">Plans</span>
        </div>

        <button
          className="add-outlet-btn"
          onClick={() => navigate("/admin/add-plan")}
        >
          ＋ Add Plan
        </button>
      </div>

      <Container className="wrap ">
        <Card className="customtable-card">
          <div className="table-responsive">
            <Table className="custom-table align-middle">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Plan</th>
                  <th>Price</th>
                  <th>Duration</th>
                  <th>Contact Views</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={7} className="text-center py-4">
                      Loading...
                    </td>
                  </tr>
                ) : plans.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="text-center py-4">
                      No plans found.
                    </td>
                  </tr>
                ) : (
                  plans.map((plan, index) => (
                    <tr key={plan._id}>
                      <td className="index">{index + 1}</td>

                      <td>
                        <div>
                          <div className="plan-nm">{plan.name}</div>


                        </div>
                      </td>

                      <td>
                        <div className="price-cell">
                          {plan.price === 0 ? "Free" : `₹${plan.price}`}
                        </div>
                      </td>

                      <td>
                        <span className="dur-badge">
                          {plan.duration}{" "}
                          {plan.duration === 1
                            ? plan.durationType.replace("s", "")
                            : plan.durationType}
                        </span>
                      </td>

                      <td>
                        {plan.limits?.contactViews === -1
                          ? "Unlimited"
                          : plan.limits?.contactViews}
                      </td>

                      <td>
                        <span
                          className={`badge ${getStatusClass(plan.status)}`}
                        >
                          {getStatusLabel(plan.status)}
                        </span>
                      </td>

                      <td>
                        <div className="actions">
                          <button
                            className="act-btn edit"
                            onClick={() =>
                              navigate(`/admin/edit-plan/${plan._id}`)
                            }
                          >
                            <MdEdit />
                          </button>

                          <button className="act-btn del">
                            <IoMdTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>

          <div className="pagination-wrap mx-3">
            <div>
              Showing 1–{plans.length} of {plans.length}
            </div>
            <Pagination className="custom-pagination">
              <Pagination.Prev disabled />
              <Pagination.Item active>1</Pagination.Item>
              <Pagination.Next disabled />
            </Pagination>
          </div>
        </Card>
      </Container>
    </>
  );
}
